/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
// import "core-js/stable";
import 'regenerator-runtime/runtime';

window.$ = window.jQuery = require('jquery');
require('magnific-popup');

window.Vue = require('vue').default;

import { VueReCaptcha } from 'vue-recaptcha-v3'
// Vue.use(VueReCaptcha, { siteKey: '6Le-nOggAAAAABChQB9S1O1Z-FbFFnLxzCwj5W1D' })
Vue.use(VueReCaptcha, { siteKey: '6LdtIpghAAAAAGDfIuNm9x482RReMWGgtoJdXEZg' })

import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import VueScrollactive from 'vue-scrollactive'
Vue.use(VueScrollactive);

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBaGX-2lFDRxNHIFytR9IIceDYdGncEDTE',
    libraries: 'places'
  }
})

import VueGtm from '@gtm-support/vue2-gtm';
//import VueRouter from 'vue-router';
//const router = new VueRouter({ routes, mode, linkActiveClass });

Vue.use(VueGtm, {
  id: 'GTM-TVCG8CJ',
  defer: false,
  enabled: true,
  debug: true,
  loadScript: true,
  //vueRouter: router,
  trackOnNextTick: false,
});

Vue.component('GmapCluster', GmapCluster)

Vue.component('app-header', () => import('./components/Header'));
Vue.component('app-sticky-nav', () => import('./components/StickyNav'));
Vue.component('app-slideshow-home', () => import('./components/SliderHome'));
Vue.component('app-our-people', () => import('./components/OurPeople'));
Vue.component('app-gallery', () => import('./components/GalleryArea'));
Vue.component('app-signup', () => import('./components/Signup'));
Vue.component('app-contact', () => import('./components/Contact'));
Vue.component('colours-section', () => import('./components/ColoursSection'));
Vue.component('battery-section', () => import('./components/BatterySection'));

Vue.component('app-map', () => import('./components/Map'));
Vue.component('app-map-clusters', () => import('./components/MapClusters'));
Vue.component('region-select', () => import('./components/RegionSelect'));
Vue.component('contact-entry-form', () => import('./components/ContactEntryForm'));
Vue.component('pricing-table', () => import('./components/PricingTable'));
Vue.component('accessories-section', () => import('./components/Accessories.vue'));

Vue.component('spec-list', () => import('./components/SpecList.vue'));

Vue.component('uber-form', () => import('./components/UberForm.vue'));


const app = new Vue({
  el: '#app',

  data: () => ({
    isLoaded: false,
    spec: null
  }),

  mounted () {
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        this.isLoaded = true
      }
    }
  },

  methods: {
    toggleSpec (index) {
      console.log(index)
      if (index === this.spec) {
        this.spec = null
      } else {
        this.spec = index
      }
    }
  }
});
